<template>
    <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
            <v-card-title>
                <h3 class="headline mb-0"><span style="color: #9C1A1A">Detalle de lote</span></h3>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="datos.papers"
                    :pagination.sync="pagination"
                    :total-items="total"
                    :rows-per-page-items="rowsPerPageItems"
                    :loading="loading"
                    row
                    wrap
                    class="elevation-1"
                >
                    <template v-slot:items="props">
                    <td>DC-{{ props.item.papel }}</td>
                    <td>{{ props.item.used ? 'Sí' : 'No' }}</td>
                    <td>{{ props.item.canceled ? 'Sí' : 'No' }}</td>
                    <td class="justify-center layout px-0">
                        <v-tooltip left>
                            <v-btn slot="activator" icon class="mx-0"  @click="editItem(props.item)">
                                <v-icon color="blue" class="mr-2">
                                    edit
                                </v-icon>
                            </v-btn>
                            <span>Eitar Papel</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-btn slot="activator" icon class="mx-0" @click="deleteItem(props.item)">
                                <v-icon color="red">
                                    delete
                                </v-icon>
                            </v-btn>
                            <span>Eliminar Papel</span>
                        </v-tooltip>
                    </td>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-form>

      <!-- dialog -->
      <v-dialog v-model="dialog" width="400" persistent>
        <v-card hover flat>
            <v-form ref="formedit" v-model="validEdit" lazy-validation enctype="multipart/form-data">
            <v-card-title>
                <h3 class="headline mb-0"><span style="color: #9C1A1A">Editar</span></h3>
            </v-card-title>
            <v-card-text>
                <v-text-field
                  ref="papel"
                  prepend-icon="code"
                  v-model="form.papel"
                  :rules="[v => !!v || 'Num Papel es requerido']"
                  :error-messages="errLote"
                  label="Papel"
                  required
                ></v-text-field>
                <v-switch
                  color="primary"
                  v-model="form.used"
                  label="Usado"
                ></v-switch>
                <v-switch
                  color="primary"
                  v-model="form.canceled"
                  label="Cancelado"
                ></v-switch>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="cerrarDialogEdit()">Cerrar</v-btn>
              <v-spacer></v-spacer>
              <v-btn :loading="loading" class="primary" @click="submit">Editar</v-btn>
            </v-card-actions>
            </v-form>
        </v-card>
      </v-dialog>
      <!-- fin dialog -->
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'

export default {

    props: {
        datos: {
            type: Object,
            required: true
        }
    },

    watch: {
        datos(v) {
            Object.assign(this.form, v)
        }
    },

  data: () => ({
    errPapel: [],
    errLote: [],
    papers: [],
    total: 0,
    pagination: {},
    rowsPerPageItems: [10, 20, 50, 100],
    valid: false,
    validEdit: false,
    dialog: false,
    loading: false,
    headers: [
        { text: 'PAPEL', align: 'left', sortable: false, value: 'papel' },
        { text: 'ASIGNADO', align: 'left', sortable: false, value: 'used' },
        { text: 'ANULADO', align: 'left', sortable: false, value: 'canceled' },
        { text: 'ACCIONES', align: 'center', value: '', sortable: false }
    ],
    form: new Form({
      id: '',
      papel: '',
      papel_old: '',
      used: false,
      canceled: false
    }),
    formOld:{
      id: '',
      papel: '',
      papel_old: '',
      used: false,
      canceled: false
    },
    editedIndex: -1,
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    editItem (item) {
      this.editedIndex = this.datos.papers.indexOf(item)
      this.form = Object.assign({}, item)
      this.form.id = this.datos.id
      this.form.papel_old = item.papel
      this.dialog = true
    },


    deleteItem (item) {
      let datos_id = this.datos.id
      let confirmDelete =  confirm(`se eliminará el PAPEL:  ${item.papel}, está seguro?`)
      if(confirmDelete){
        axios.delete(`/api/administration/cobranza/delete-detail-papel/${datos_id}/${item.papel}`)
          .then((resp) => {
            this.$emit('closeDialogPaperDetail', resp.data)
          })
          .catch(e => {
            console.log(e.response);
                           this.loading = false
                if (e.response.data.errors) {
                  // this.form.errors.errors = e.response.data.errors
                  if (e.response.data.errors.papel_comprado) {
                    this.$store.dispatch('responseMessage', {
                      type: 'error',
                      text: e.response.data.errors.papel_comprado
                    })
                  }
                }else {
                  this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: e.response.data.error
                  })
                }
          });
      }
    },

    submit () {
      if (this.$refs.formedit.validate()) {
        this.loading = true
        this.submitFormPapers()
      }
    },

    async submitFormPapers () {
      try {
        const { data } = await axios.post('/api/administration/cobranza/edit_paper_detail', this.form)
        this.cerrarDialogEdit(data)
      } catch (e) {
        console.log(e.response, 'data error create')
        this.loading = false
        if (e.response.data.errors) {
          // this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.papel) {
            this.$refs.papel.focus()
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.papel[0]
            })
          }else if(e.response.data.errors.outlote) {
            this.$refs.papel.focus()
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.outlote
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }

    },

    cerrarDialog (data) {
      this.$emit('closeDialogPaper', data)
      this.$nextTick(() => {
          this.$refs.form.resetValidation()
          this.loading = false
      })
    },

    cerrarDialogEdit (data) {
        this.$emit('closeDialogPaperDetail', data)
        this.dialog = false
        this.$nextTick(() => {
          this.$refs.formedit.resetValidation()
          this.loading = false
        })
    },

    cerrarDialogDelete (data) {
        this.$emit('closeDialogPaperDelete', data)
        this.$nextTick(() => {
          this.$refs.formedit.resetValidation()
          this.loading = false
        })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/FormPapersDetails.vue